import {useCallback, useState} from 'react';
import {getTranslatedLanguages, getValue, ofDefault, setValue, StringTranslations} from '../types/StringTranslations';
import {DEFAULT_LANGUAGE} from '../i18n/config';
import {useTranslation} from "react-i18next";

interface UseTranslatableFieldOptions {
  initialValue?: StringTranslations;
}

interface UseTranslatableFieldReturn {
  translations: StringTranslations;
  currentLanguage: string;
  setCurrentLanguage: (lang: string) => void;
  currentValue: string;
  setCurrentValue: (value: string) => void;
  translatedLanguages: string[];
  setTranslations: (translations: StringTranslations) => void;
}

export const useTranslatableField = (
  options: UseTranslatableFieldOptions = {}
): UseTranslatableFieldReturn => {
  const {i18n} = useTranslation()

  const {
    initialValue = ofDefault('', DEFAULT_LANGUAGE)
  } = options;

  const [translations, setTranslations] = useState<StringTranslations>(initialValue);
  const [currentLanguage, setCurrentLanguage] = useState<string>(i18n.language);

  const currentValue = getValue(translations, currentLanguage);

  const setCurrentValue = useCallback((value: string) => {
    setTranslations(prev => setValue(prev, currentLanguage, value));
  }, [currentLanguage]);

  const translatedLanguages = getTranslatedLanguages(translations);

  return {
    translations,
    currentLanguage,
    setCurrentLanguage,
    currentValue,
    setCurrentValue,
    translatedLanguages,
    setTranslations,
  };
};

